import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';

@Component({
  standalone: true,
  selector: 'app-go-back-btn',
  templateUrl: './go-back-btn.component.html',
  imports: [CommonModule, LucideAngularModule],
})
export class GoBackBtnComponent implements OnInit {
  @Output() goBack = new EventEmitter<void>();
  constructor() {}

  ngOnInit() {}

  onGoBack() {
    this.goBack.emit();
  }
}
